import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=06944eef&scoped=true"
import script from "./AccountDetail.vue?vue&type=script&lang=js"
export * from "./AccountDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=06944eef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06944eef",
  null
  
)

export default component.exports